// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faFileAlt,
//   faUser,
//   faEnvelope,
//   faPhone,
//   faMapMarkerAlt,
//   faStar,
//   faGraduationCap,
//   faBriefcase,
//   faClipboardList,
//   faChevronLeft,
//   faSpinner,
//   faExclamationTriangle,
//   faIdBadge,
//   faTools,
//   faHistory,
//   faBuilding,
//   faClock,
//   faPercentage,
//   faLightbulb,
//   faCalendarAlt,
// } from '@fortawesome/free-solid-svg-icons';
// import { backend_url } from '../config';
// import '../CandidateProfile.css';

// // Stage colors consistent with SavedCandidates
// const stageColors = {
//   'Not Started': 'var(--coreops-status-grey, #adb5bd)',
//   'Resume Screening': 'var(--coreops-status-light-blue, #a9def9)',
//   'Phone Interview': 'var(--coreops-status-sky-blue, #72d5fd)',
//   'Technical Assessment': 'var(--coreops-status-teal, #2ab7ca)',
//   'On-site Interview': 'var(--coreops-secondary, #00A4CC)',
//   'Reference Check': 'var(--coreops-status-dark-blue, #0077b6)',
//   'Offer Extended': 'var(--coreops-status-greenish-teal, #2a9d8f)',
//   Hired: 'var(--coreops-success-text, #28a745)',
//   Rejected: 'var(--coreops-error-text, #d9534f)',
//   'On Hold': 'var(--coreops-status-yellow, #fdc500)',
// };

// function CandidateProfile() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [candidate, setCandidate] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchCandidateProfile();
//   }, [id]);

//   const fetchCandidateProfile = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const baseEndpoint = 'candidates';
//       const response = await fetch(`${backend_url}/${baseEndpoint}/${id}`);

//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(
//           errorData.message || `Failed to fetch candidate: ${response.status}`
//         );
//       }

//       const data = await response.json();
//       const candidateData = data.candidate || data;

//       // DEBUG: Log the actual data structure
//       console.log(
//         '🔍 DEBUG - Full candidate data structure:',
//         JSON.stringify(candidateData, null, 2)
//       );
//       console.log(
//         '🔍 DEBUG - Companies worked:',
//         candidateData.companiesWorked
//       );
//       console.log('🔍 DEBUG - Education:', candidateData.education);
//       console.log('🔍 DEBUG - Analysis object:', candidateData.analysis);

//       setCandidate(candidateData);
//     } catch (err) {
//       console.error('Error fetching candidate profile:', err);
//       setError(
//         err.message || 'Failed to load candidate profile. Please try again.'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Enhanced helper to safely access nested properties
//   const getAnalysisData = (key, defaultValue = 'N/A') => {
//     if (!candidate) return defaultValue;

//     // Check multiple possible locations for the data
//     const possibleLocations = [
//       candidate.analysis?.[key],
//       candidate[key],
//       candidate.resumeAnalysis?.[key],
//       candidate.data?.[key],
//     ];

//     for (let location of possibleLocations) {
//       if (location !== undefined && location !== null && location !== 'N/A') {
//         console.log(`🔍 DEBUG - Found ${key} at location:`, location);
//         return location;
//       }
//     }

//     console.log(
//       `⚠️ DEBUG - Could not find ${key}, using default:`,
//       defaultValue
//     );
//     return defaultValue;
//   };

//   if (loading) {
//     return (
//       <div className='coreops-page-container candidate-profile-page'>
//         <div className='coreops-content-wrapper'>
//           <div className='coreops-message-container loading'>
//             <FontAwesomeIcon icon={faSpinner} spin size='3x' />
//             <p>Loading Candidate Profile...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className='coreops-page-container candidate-profile-page'>
//         <div className='coreops-content-wrapper'>
//           <div className='coreops-message-container error'>
//             <FontAwesomeIcon icon={faExclamationTriangle} size='3x' />
//             <p className='error-title'>Error Loading Profile</p>
//             <p>{error}</p>
//             <button
//               onClick={fetchCandidateProfile}
//               className='coreops-button coreops-button-primary'
//             >
//               Try Again
//             </button>
//             <Link
//               to={'/candidates'}
//               className='coreops-button coreops-button-secondary'
//               style={{ marginLeft: '10px' }}
//             >
//               <FontAwesomeIcon icon={faChevronLeft} /> Back to List
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!candidate) {
//     return (
//       <div className='coreops-page-container candidate-profile-page'>
//         <div className='coreops-content-wrapper'>
//           <div className='coreops-message-container empty'>
//             <FontAwesomeIcon icon={faUser} size='4x' />
//             <p className='empty-title'>Candidate Not Found</p>
//             <p className='empty-subtitle'>
//               The requested candidate profile could not be located.
//             </p>
//             <Link
//               to={'/candidates'}
//               className='coreops-button coreops-button-primary'
//             >
//               <FontAwesomeIcon icon={faChevronLeft} /> Back to Candidate List
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Extract data using the enhanced helper
//   const candidateName = getAnalysisData('name');
//   const candidateEmail = getAnalysisData('email');
//   const candidatePhone = getAnalysisData('phone', null);
//   const candidateLocation = getAnalysisData('location', null);
//   const similarityScore = getAnalysisData('similarityScore', 0);
//   const resumeSummary = getAnalysisData(
//     'resumeSummary',
//     'No summary available.'
//   );
//   const keySkills = getAnalysisData('keySkills', []);
//   const totalExperienceYears = getAnalysisData('totalExperienceYears', 'N/A');
//   const companiesWorked = getAnalysisData('companiesWorked', []);
//   const educationList = getAnalysisData('education', []);
//   const interviewStatus = candidate.interviewStatus || 'Not Started';

//   // DEBUG: Log extracted values
//   console.log('🔍 DEBUG - Extracted companies:', companiesWorked);
//   console.log('🔍 DEBUG - Extracted education:', educationList);

//   return (
//     <div className='coreops-page-container candidate-profile-page'>
//       <div className='coreops-content-wrapper'>
//         <div className='coreops-profile-header'>
//           <Link to={'/candidates'} className='coreops-back-link'>
//             <FontAwesomeIcon icon={faChevronLeft} /> Back to Candidate List
//           </Link>
//         </div>

//         <div className='coreops-profile-layout'>
//           {/* Sidebar */}
//           <aside className='coreops-profile-sidebar'>
//             <div className='coreops-profile-avatar-container'>
//               <FontAwesomeIcon
//                 icon={faIdBadge}
//                 className='coreops-profile-avatar-icon'
//               />
//             </div>
//             <h2 className='coreops-candidate-name'>{candidateName}</h2>
//             <div className='coreops-candidate-status'>
//               <span
//                 className='coreops-status-pill large'
//                 style={{ backgroundColor: stageColors[interviewStatus] }}
//               >
//                 {interviewStatus}
//               </span>
//             </div>

//             <div className='coreops-contact-info'>
//               <div className='coreops-info-item'>
//                 <FontAwesomeIcon
//                   icon={faEnvelope}
//                   className='coreops-info-icon'
//                 />
//                 <a
//                   href={`mailto:${candidateEmail}`}
//                   title={`Email ${candidateName}`}
//                 >
//                   {candidateEmail}
//                 </a>
//               </div>
//               {candidatePhone && candidatePhone !== 'N/A' && (
//                 <div className='coreops-info-item'>
//                   <FontAwesomeIcon
//                     icon={faPhone}
//                     className='coreops-info-icon'
//                   />
//                   <span>{candidatePhone}</span>
//                 </div>
//               )}
//               {candidateLocation && candidateLocation !== 'N/A' && (
//                 <div className='coreops-info-item'>
//                   <FontAwesomeIcon
//                     icon={faMapMarkerAlt}
//                     className='coreops-info-icon'
//                   />
//                   <span>{candidateLocation}</span>
//                 </div>
//               )}
//             </div>

//             <div className='coreops-score-card'>
//               <div className='score-value'>{similarityScore}%</div>
//               <div className='score-label'>Match Score</div>
//               <FontAwesomeIcon icon={faStar} className='score-icon-bg' />
//             </div>
//           </aside>

//           {/* Main Content */}
//           <main className='coreops-profile-main-content'>
//             <section className='coreops-profile-card'>
//               <h3 className='coreops-card-title'>
//                 <FontAwesomeIcon icon={faLightbulb} /> AI Resume Summary
//               </h3>
//               <p className='coreops-summary-text'>{resumeSummary}</p>
//             </section>

//             <section className='coreops-profile-card'>
//               <h3 className='coreops-card-title'>
//                 <FontAwesomeIcon icon={faTools} /> Key Skills
//               </h3>
//               {keySkills && Array.isArray(keySkills) && keySkills.length > 0 ? (
//                 <div className='coreops-skills-list'>
//                   {keySkills.map((skill, index) => (
//                     <span key={index} className='coreops-skill-tag'>
//                       {skill}
//                     </span>
//                   ))}
//                 </div>
//               ) : (
//                 <div>
//                   <p className='coreops-no-data-text'>
//                     No key skills extracted.
//                   </p>
//                   <p style={{ fontSize: '12px', color: '#666' }}>
//                     DEBUG: keySkills value = {JSON.stringify(keySkills)}
//                   </p>
//                 </div>
//               )}
//             </section>

//             <section className='coreops-profile-card'>
//               <h3 className='coreops-card-title'>
//                 <FontAwesomeIcon icon={faHistory} /> Professional Experience
//               </h3>
//               <p className='coreops-experience-total'>
//                 Total Estimated Experience:{' '}
//                 <strong>
//                   {totalExperienceYears}{' '}
//                   {totalExperienceYears === 1 ? 'year' : 'years'}
//                 </strong>
//               </p>
//               {companiesWorked &&
//               Array.isArray(companiesWorked) &&
//               companiesWorked.length > 0 ? (
//                 <div className='coreops-experience-list'>
//                   {companiesWorked.map((exp, index) => (
//                     <div key={index} className='coreops-experience-item'>
//                       <div className='coreops-item-header'>
//                         <FontAwesomeIcon
//                           icon={faBuilding}
//                           className='coreops-item-icon'
//                         />
//                         <span className='coreops-item-main-title'>
//                           {exp.companyName || 'N/A'}
//                         </span>
//                       </div>
//                       <div className='coreops-item-details'>
//                         <p className='coreops-item-subtitle'>
//                           {exp.role || 'N/A'}
//                         </p>
//                         {exp.duration && exp.duration !== 'N/A' && (
//                           <p className='coreops-item-meta'>
//                             <FontAwesomeIcon icon={faClock} /> {exp.duration}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div>
//                   <p className='coreops-no-data-text'>
//                     No professional experience listed or extracted.
//                   </p>
//                   <p style={{ fontSize: '12px', color: '#666' }}>
//                     DEBUG: companiesWorked value ={' '}
//                     {JSON.stringify(companiesWorked)}
//                   </p>
//                 </div>
//               )}
//             </section>

//             <section className='coreops-profile-card'>
//               <h3 className='coreops-card-title'>
//                 <FontAwesomeIcon icon={faGraduationCap} /> Education
//               </h3>
//               {educationList &&
//               Array.isArray(educationList) &&
//               educationList.length > 0 ? (
//                 <div className='coreops-experience-list'>
//                   {educationList.map((edu, index) => (
//                     <div key={index} className='coreops-experience-item'>
//                       <div className='coreops-item-header'>
//                         <FontAwesomeIcon
//                           icon={faGraduationCap}
//                           className='coreops-item-icon'
//                         />
//                         <span className='coreops-item-main-title'>
//                           {edu.institution || 'N/A'}
//                         </span>
//                       </div>
//                       <div className='coreops-item-details'>
//                         <p className='coreops-item-subtitle'>
//                           {edu.degree || 'N/A'}
//                         </p>
//                         {edu.year && edu.year !== 'N/A' && (
//                           <p className='coreops-item-meta'>
//                             <FontAwesomeIcon icon={faCalendarAlt} /> {edu.year}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div>
//                   <p className='coreops-no-data-text'>
//                     No education details listed or extracted.
//                   </p>
//                   <p style={{ fontSize: '12px', color: '#666' }}>
//                     DEBUG: educationList value = {JSON.stringify(educationList)}
//                   </p>
//                 </div>
//               )}
//             </section>
//           </main>
//         </div>
//         <footer className='coreops-footer results-sub-footer'>
//           <p>
//             © {new Date().getFullYear()} CoreOps.ai - Candidate Profile View
//           </p>
//         </footer>
//       </div>
//     </div>
//   );
// }

// export default CandidateProfile;

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileAlt,
  faUser,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faStar,
  faGraduationCap,
  faBriefcase,
  faClipboardList,
  faChevronLeft,
  faSpinner,
  faExclamationTriangle,
  faIdBadge,
  faTools,
  faHistory,
  faBuilding,
  faClock,
  faPercentage,
  faLightbulb,
  faCalendarAlt,
} from '@fortawesome/free-solid-svg-icons';
import { backend_url } from '../config';
import '../CandidateProfile.css';

// Stage colors consistent with SavedCandidates
const stageColors = {
  'Not Started': 'var(--coreops-status-grey, #adb5bd)',
  'Resume Screening': 'var(--coreops-status-light-blue, #a9def9)',
  'Phone Interview': 'var(--coreops-status-sky-blue, #72d5fd)',
  'Technical Assessment': 'var(--coreops-status-teal, #2ab7ca)',
  'On-site Interview': 'var(--coreops-secondary, #00A4CC)',
  'Reference Check': 'var(--coreops-status-dark-blue, #0077b6)',
  'Offer Extended': 'var(--coreops-status-greenish-teal, #2a9d8f)',
  Hired: 'var(--coreops-success-text, #28a745)',
  Rejected: 'var(--coreops-error-text, #d9534f)',
  'On Hold': 'var(--coreops-status-yellow, #fdc500)',
};

function CandidateProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isQualifiedCandidate, setIsQualifiedCandidate] = useState(false);

  useEffect(() => {
    fetchCandidateProfile();
  }, [id]);

  const fetchCandidateProfile = async () => {
    try {
      setLoading(true);
      setError(null);

      // Check if we're coming from qualified candidates page
      const fromQualified =
        location.state?.fromQualified ||
        document.referrer.includes('/qualified-candidates');

      // Try qualified candidates endpoint first if coming from that page
      let response;
      let candidateData;

      if (fromQualified) {
        try {
          response = await fetch(`${backend_url}/qualified-candidates/${id}`);
          if (response.ok) {
            const data = await response.json();
            candidateData = data.candidate || data;
            setIsQualifiedCandidate(true);
          }
        } catch (err) {
          console.log(
            'Failed to fetch from qualified-candidates, trying regular candidates...'
          );
        }
      }

      // If we didn't get data from qualified candidates, try regular candidates endpoint
      if (!candidateData) {
        response = await fetch(`${backend_url}/candidates/${id}`);
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(
            errorData.message || `Failed to fetch candidate: ${response.status}`
          );
        }
        const data = await response.json();
        candidateData = data.candidate || data;
        setIsQualifiedCandidate(false);
      }

      // DEBUG: Log the actual data structure
      console.log(
        '🔍 DEBUG - Full candidate data structure:',
        JSON.stringify(candidateData, null, 2)
      );
      console.log(
        '🔍 DEBUG - Companies worked:',
        candidateData.companiesWorked
      );
      console.log('🔍 DEBUG - Education:', candidateData.education);
      console.log('🔍 DEBUG - Analysis object:', candidateData.analysis);

      setCandidate(candidateData);
    } catch (err) {
      console.error('Error fetching candidate profile:', err);
      setError(
        err.message || 'Failed to load candidate profile. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  // Enhanced helper to safely access nested properties
  const getAnalysisData = (key, defaultValue = 'N/A') => {
    if (!candidate) return defaultValue;

    // Check multiple possible locations for the data
    const possibleLocations = [
      candidate.analysis?.[key],
      candidate[key],
      candidate.resumeAnalysis?.[key],
      candidate.data?.[key],
    ];

    for (let location of possibleLocations) {
      if (location !== undefined && location !== null && location !== 'N/A') {
        console.log(`🔍 DEBUG - Found ${key} at location:`, location);
        return location;
      }
    }

    console.log(
      `⚠️ DEBUG - Could not find ${key}, using default:`,
      defaultValue
    );
    return defaultValue;
  };

  // Determine the back link based on where we came from
  const getBackLink = () => {
    if (isQualifiedCandidate || location.state?.fromQualified) {
      return '/qualified-candidates';
    }
    return '/candidates';
  };

  const getBackLinkText = () => {
    if (isQualifiedCandidate || location.state?.fromQualified) {
      return 'Back to Qualified Candidates';
    }
    return 'Back to Candidate List';
  };

  if (loading) {
    return (
      <div className='coreops-page-container candidate-profile-page'>
        <div className='coreops-content-wrapper'>
          <div className='coreops-message-container loading'>
            <FontAwesomeIcon icon={faSpinner} spin size='3x' />
            <p>Loading Candidate Profile...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='coreops-page-container candidate-profile-page'>
        <div className='coreops-content-wrapper'>
          <div className='coreops-message-container error'>
            <FontAwesomeIcon icon={faExclamationTriangle} size='3x' />
            <p className='error-title'>Error Loading Profile</p>
            <p>{error}</p>
            <button
              onClick={fetchCandidateProfile}
              className='coreops-button coreops-button-primary'
            >
              Try Again
            </button>
            <Link
              to={getBackLink()}
              className='coreops-button coreops-button-secondary'
              style={{ marginLeft: '10px' }}
            >
              <FontAwesomeIcon icon={faChevronLeft} /> {getBackLinkText()}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (!candidate) {
    return (
      <div className='coreops-page-container candidate-profile-page'>
        <div className='coreops-content-wrapper'>
          <div className='coreops-message-container empty'>
            <FontAwesomeIcon icon={faUser} size='4x' />
            <p className='empty-title'>Candidate Not Found</p>
            <p className='empty-subtitle'>
              The requested candidate profile could not be located.
            </p>
            <Link
              to={getBackLink()}
              className='coreops-button coreops-button-primary'
            >
              <FontAwesomeIcon icon={faChevronLeft} /> {getBackLinkText()}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Extract data using the enhanced helper
  const candidateName = getAnalysisData('name');
  const candidateEmail = getAnalysisData('email');
  const candidatePhone = getAnalysisData('phone', null);
  const candidateLocation = getAnalysisData('location', null);
  const similarityScore = getAnalysisData('similarityScore', 0);
  const resumeSummary = getAnalysisData(
    'resumeSummary',
    'No summary available.'
  );
  const keySkills = getAnalysisData('keySkills', []);
  const totalExperienceYears = getAnalysisData('totalExperienceYears', 'N/A');
  const companiesWorked = getAnalysisData('companiesWorked', []);
  const educationList = getAnalysisData('education', []);
  const interviewStatus = candidate.interviewStatus || 'Not Started';

  // DEBUG: Log extracted values
  console.log('🔍 DEBUG - Extracted companies:', companiesWorked);
  console.log('🔍 DEBUG - Extracted education:', educationList);

  return (
    <div className='coreops-page-container candidate-profile-page'>
      <div className='coreops-content-wrapper'>
        <div className='coreops-profile-header'>
          <Link to={getBackLink()} className='coreops-back-link'>
            <FontAwesomeIcon icon={faChevronLeft} /> {getBackLinkText()}
          </Link>
          {isQualifiedCandidate && (
            <div className='qualified-badge'>
              <span className='badge-text'>✓ Qualified Candidate</span>
            </div>
          )}
        </div>

        <div className='coreops-profile-layout'>
          {/* Sidebar */}
          <aside className='coreops-profile-sidebar'>
            <div className='coreops-profile-avatar-container'>
              <FontAwesomeIcon
                icon={faIdBadge}
                className='coreops-profile-avatar-icon'
              />
            </div>
            <h2 className='coreops-candidate-name'>{candidateName}</h2>
            <div className='coreops-candidate-status'>
              <span
                className='coreops-status-pill large'
                style={{ backgroundColor: stageColors[interviewStatus] }}
              >
                {interviewStatus}
              </span>
            </div>

            <div className='coreops-contact-info'>
              <div className='coreops-info-item'>
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className='coreops-info-icon'
                />
                <a
                  href={`mailto:${candidateEmail}`}
                  title={`Email ${candidateName}`}
                >
                  {candidateEmail}
                </a>
              </div>
              {candidatePhone && candidatePhone !== 'N/A' && (
                <div className='coreops-info-item'>
                  <FontAwesomeIcon
                    icon={faPhone}
                    className='coreops-info-icon'
                  />
                  <span>{candidatePhone}</span>
                </div>
              )}
              {candidateLocation && candidateLocation !== 'N/A' && (
                <div className='coreops-info-item'>
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className='coreops-info-icon'
                  />
                  <span>{candidateLocation}</span>
                </div>
              )}
            </div>

            <div className='coreops-score-card'>
              <div className='score-value'>{similarityScore}%</div>
              <div className='score-label'>Match Score</div>
              <FontAwesomeIcon icon={faStar} className='score-icon-bg' />
            </div>
          </aside>

          {/* Main Content */}
          <main className='coreops-profile-main-content'>
            <section className='coreops-profile-card'>
              <h3 className='coreops-card-title'>
                <FontAwesomeIcon icon={faLightbulb} /> AI Resume Summary
              </h3>
              <p className='coreops-summary-text'>{resumeSummary}</p>
            </section>

            <section className='coreops-profile-card'>
              <h3 className='coreops-card-title'>
                <FontAwesomeIcon icon={faTools} /> Key Skills
              </h3>
              {keySkills && Array.isArray(keySkills) && keySkills.length > 0 ? (
                <div className='coreops-skills-list'>
                  {keySkills.map((skill, index) => (
                    <span key={index} className='coreops-skill-tag'>
                      {skill}
                    </span>
                  ))}
                </div>
              ) : (
                <div>
                  <p className='coreops-no-data-text'>
                    No key skills extracted.
                  </p>
                  <p style={{ fontSize: '12px', color: '#666' }}>
                    DEBUG: keySkills value = {JSON.stringify(keySkills)}
                  </p>
                </div>
              )}
            </section>

            <section className='coreops-profile-card'>
              <h3 className='coreops-card-title'>
                <FontAwesomeIcon icon={faHistory} /> Professional Experience
              </h3>
              <p className='coreops-experience-total'>
                Total Estimated Experience:{' '}
                <strong>
                  {totalExperienceYears}{' '}
                  {totalExperienceYears === 1 ? 'year' : 'years'}
                </strong>
              </p>
              {companiesWorked &&
              Array.isArray(companiesWorked) &&
              companiesWorked.length > 0 ? (
                <div className='coreops-experience-list'>
                  {companiesWorked.map((exp, index) => (
                    <div key={index} className='coreops-experience-item'>
                      <div className='coreops-item-header'>
                        <FontAwesomeIcon
                          icon={faBuilding}
                          className='coreops-item-icon'
                        />
                        <span className='coreops-item-main-title'>
                          {exp.companyName || 'N/A'}
                        </span>
                      </div>
                      <div className='coreops-item-details'>
                        <p className='coreops-item-subtitle'>
                          {exp.role || 'N/A'}
                        </p>
                        {exp.duration && exp.duration !== 'N/A' && (
                          <p className='coreops-item-meta'>
                            <FontAwesomeIcon icon={faClock} /> {exp.duration}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <p className='coreops-no-data-text'>
                    No professional experience listed or extracted.
                  </p>
                  <p style={{ fontSize: '12px', color: '#666' }}>
                    DEBUG: companiesWorked value ={' '}
                    {JSON.stringify(companiesWorked)}
                  </p>
                </div>
              )}
            </section>

            <section className='coreops-profile-card'>
              <h3 className='coreops-card-title'>
                <FontAwesomeIcon icon={faGraduationCap} /> Education
              </h3>
              {educationList &&
              Array.isArray(educationList) &&
              educationList.length > 0 ? (
                <div className='coreops-experience-list'>
                  {educationList.map((edu, index) => (
                    <div key={index} className='coreops-experience-item'>
                      <div className='coreops-item-header'>
                        <FontAwesomeIcon
                          icon={faGraduationCap}
                          className='coreops-item-icon'
                        />
                        <span className='coreops-item-main-title'>
                          {edu.institution || 'N/A'}
                        </span>
                      </div>
                      <div className='coreops-item-details'>
                        <p className='coreops-item-subtitle'>
                          {edu.degree || 'N/A'}
                        </p>
                        {edu.year && edu.year !== 'N/A' && (
                          <p className='coreops-item-meta'>
                            <FontAwesomeIcon icon={faCalendarAlt} /> {edu.year}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <p className='coreops-no-data-text'>
                    No education details listed or extracted.
                  </p>
                  <p style={{ fontSize: '12px', color: '#666' }}>
                    DEBUG: educationList value = {JSON.stringify(educationList)}
                  </p>
                </div>
              )}
            </section>
          </main>
        </div>
        <footer className='coreops-footer results-sub-footer'>
          <p>
            © {new Date().getFullYear()} CoreOps.ai - Candidate Profile View
          </p>
        </footer>
      </div>
    </div>
  );
}

export default CandidateProfile;
